import { BuiltInTypes } from "./BuiltInTypes";
import { NAMESPACE } from "./_Namespace";

export class Nullable
{
    public static classNamespace = NAMESPACE + "Nullable";
    public static className = "Nullable";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    public static getUnderlyingType(type: BuiltInTypes): BuiltInTypes | undefined
    {
        const
            nullableMatches = /System\.Nullable`1\[\[(.*)?\]\], System.Private.CoreLib/.exec(type);

        if (nullableMatches)
            return nullableMatches[1] as BuiltInTypes;
    }
}